import { setPartners } from './partners.actions';
import { appointmentDraftActions } from '~/api';
import { errorMessages, errorMessagesActions, errorTypes } from '~/components/messages';

export const getSelectedPartner = (selectedPartnerId, partners) => {
  if (partners.length > 1) {
    return partners.find(({ id }) => id === selectedPartnerId);
  }
  return partners[0];
};

export const handleLoadedPartners = (dispatch, shopName, selectedPartnerId, partners) => {
  if (partners.length === 0) {
    const message = errorMessages[errorTypes.NO_AVAILABLE_PARTNERS_ERROR];
    const actionMessage = {
      type: errorTypes.NO_AVAILABLE_PARTNERS_ERROR,
      title: message.createTitle(shopName),
    };
    dispatch(errorMessagesActions.resetErrorMessagesWith([actionMessage]));
  } else {
    dispatch(setPartners(partners));
    dispatch(appointmentDraftActions.setPartner(getSelectedPartner(selectedPartnerId, partners)));
  }
  return Promise.resolve(partners);
};
